export var defaultConfig = {
    apiUrl: 'http://localhost:8080/api',
    accountsUrl: 'http://localhost:8000',
};
export var envConfigs = {
    production: {
        apiUrl: 'https://api.hummingbirdtech.com',
        accountsUrl: 'https://accounts.hummingbirdtech.com',
    },
    staging: {
        apiUrl: 'https://api.staging.hummingbirdtech.com',
        accountsUrl: 'https://accounts.staging.hummingbirdtech.com',
    },
};
//# sourceMappingURL=config.js.map